import { Badge, Button, Divider, Empty, Popconfirm, Radio } from "antd";
import React, { useEffect, useState } from "react";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { getApi, postApi } from "../../services/apiService/fetchMethod";
import { Grid } from "@mui/material";
import styles from "./style.module.css";
import { socket, socket2 } from "../../socket/socket";
import getUserData from "../../utils/getUserData";
import axios from "axios";
import NewCardComp from "./NewCardCop";
import HlsVideoPlayer from "./HlsVideoPlayer";
import MainLoader from "../../commonComponents/loader/MainLoader";
import { Collapse } from "antd";
import { apiUrl, appendApi } from "../../services/apiService/baseUrl";
import {
  DeleteOutlined,
  PlusSquareOutlined,
  MinusSquareOutlined,
} from "@ant-design/icons";
import Lottie from "react-lottie";
import VideoJson from "../../assets/json/video.json";
import { FloatButton } from "antd";
import tostMessage from "../../utils/tostMessage";
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: VideoJson,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
function NewPlayGround() {
  const [options, setOptions] = useState([]);
  const [allAlert, setAllAlert] = useState([]);
  const [selectedAlert, setSelectedAllAlert] = useState({});
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [deviceList, setDeviceList] = useState({});
  const [hlsLink, setHlsLink] = useState();
  const [latestYml, setLatestYml] = useState({});
  const [editYml, setEdittYml] = useState([]);
  const [reRun, setRerun] = useState(false);
  const [reRun2, setRerun2] = useState(false);
  const [voilationData, setVoilationData] = useState({});
  const [timeSeriesData, setTimeSeriesData] = useState({});
  const [selectedYml, setSelectedYml] = useState([]);
  const [loading, setloading] = useState(true);
  const [loading2, setloading2] = useState(false);
  let { selectedProject } = getUserData();
  selectedProject = selectedProject?.value;
  let gpu = localStorage.getItem("gpu");
  useEffect(() => {
    (async () => {
      const url = apiEndPoint().GET_USECASE;
      const url2 = apiEndPoint().DEVICE_WITH_ID;
      setloading(true);
      try {
        const [useCaseResponse, deviceResponse] = await Promise.all([
          getApi({ url }),
          getApi({ url: url2 }),
        ]);
        if (useCaseResponse.status === 200) {
          const { data } = useCaseResponse;
          setOptions(data?.data?.tabs);
          setSelectedOptions(data?.data?.tabs[0]?.value);
          setAllAlert(data?.data?.data);
          if (data?.data?.data[data?.data?.tabs[0]?.value]) {
            setSelectedAllAlert(data?.data?.data[data?.data?.tabs[0]?.value]);
          } else {
            setSelectedAllAlert({});
          }
        }
        if (deviceResponse.status === 200) {
          setDeviceList(deviceResponse?.data?.data);
        }

        setloading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      if (gpu && gpu !== "undefined") {
        const url3 = apiEndPoint().GET_YML_FOR_UI + `?deviceId=${gpu}`;
        const [ymlDoc] = await Promise.all([getApi({ url: url3 })]);
        if (ymlDoc.status === 200) {
          setLatestYml(ymlDoc.data.data);
          if (ymlDoc?.data?.data?.usecaseDetails?.length === 0) {
            setHlsLink(null);
          }
        }
      }
    })();
  }, [reRun, reRun2, gpu]);
  useEffect(() => {
    let rtspUrl = null;
    if (!hlsLink) {
      rtspUrl = null;
    }
    try {
      socket.on("violation", async (data) => {
        if (
          selectedProject === data?.project_id &&
          data?.bucket_type_id === selectedOptions &&
          data?.device_id === localStorage.getItem("gpu")
        ) {
          // console.log(data, "<=VIOLATION=>");
          if (rtspUrl !== data?.rtsp_url) {
            if (data?.rtsp_url) {
              setloading2(true);
              rtspUrl = data?.rtsp_url;
              setHlsLink(null);
              try {
                const config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: apiUrl,
                  headers: {
                    Authorization:
                      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6ImFyeWEiLCJkb21haW4iOiJhcnlhIiwiaXAiOlsiMTcyIiwiMTAzIl0sImV4cGlyeSI6IjA0LzA4LzIwMjgsMTU6MDA6MjMifQ.YV4aGFrHQlVtqPXByG6xUq90t-8pYjR3AE0FdfSZnWg",
                    "Content-Type": "application/json",
                  },
                  data: JSON.stringify({
                    uri: data.rtsp_url,
                    alias: "retail",
                  }),
                };
                try {
                  const response = await axios.request(config);
                  if (response?.data && response?.data.uri) {
                    setHlsLink(`${appendApi}${response.data.uri}`);
                    setRerun2((pre) => !pre);
                  }
                } catch (error) {
                  console.error(
                    "Network error with config request:",
                    error.message
                  );
                  setRerun2((pre) => !pre);
                  socket.emit("start_pipeline", {
                    project_id: selectedProject,
                    bucket_type_id: selectedOptions,
                    sent_by: "app",
                  });
                }
                setloading(false);
              } catch (error) {
                console.error("Unexpected error:", error);
              }
            }
            setloading2(false);
          }
          setVoilationData(data);
        }
      });
      socket.on("time_series", async (data) => {
        // console.log(data, "<=time_series=>");
        if (
          selectedProject === data?.project_id &&
          data?.bucket_type_id === selectedOptions &&
          data?.device_id === localStorage.getItem("gpu")
        ) {
          if (rtspUrl !== data?.rtsp_url) {
            if (data?.rtsp_url) {
              setloading2(true);
              rtspUrl = data?.rtsp_url;
              setHlsLink(null);
              try {
                const config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: apiUrl,
                  headers: {
                    Authorization:
                      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6ImFyeWEiLCJkb21haW4iOiJhcnlhIiwiaXAiOlsiMTcyIiwiMTAzIl0sImV4cGlyeSI6IjA0LzA4LzIwMjgsMTU6MDA6MjMifQ.YV4aGFrHQlVtqPXByG6xUq90t-8pYjR3AE0FdfSZnWg",
                    "Content-Type": "application/json",
                  },
                  data: JSON.stringify({
                    uri: data.rtsp_url,
                    alias: "retail",
                  }),
                };
                try {
                  const response = await axios.request(config);
                  if (response?.data && response?.data.uri) {
                    setHlsLink(`${appendApi}${response.data.uri}`);
                    setRerun2((pre) => !pre);
                  }
                } catch (error) {
                  console.error(
                    "Network error with config request:",
                    error.message
                  );
                  setRerun2((pre) => !pre);
                  socket.emit("start_pipeline", {
                    project_id: selectedProject,
                    bucket_type_id: selectedOptions,
                    sent_by: "app",
                  });
                }
                setloading(false);
              } catch (error) {
                console.error("Unexpected error:", error);
              }
            }
            setloading2(false);
          }
          setTimeSeriesData(data);
        }
      });
      socket.on("start_pipeline", async (data) => {
        if (selectedProject === data?.project_id) {
          if (data?.sent_by === "ME") {
            setRerun2((pre) => !pre);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  }, [selectedOptions, selectedProject]);
  useEffect(() => {
    if (
      Object.keys(selectedAlert)?.length > 0 &&
      Object.keys(latestYml)?.length > 0
    ) {
      let data = latestYml?.usecaseDetails?.filter((item) =>
        Object.keys(selectedAlert)?.includes(item?.clientData?.usecaseId)
      );
      data = data?.map((item) => item?.clientData);
      setEdittYml(data);
    } else {
      setEdittYml([]);
    }
  }, [selectedAlert, reRun, latestYml]);
  const handleSelect = (e) => {
    setSelectedOptions(e.target.value);
    setSelectedAllAlert(allAlert[e.target.value]);
  };
  const handleSelcet = async (alertId, camId, name, isTrue) => {
    if (isTrue) {
      setSelectedYml((pre) =>
        pre.filter(
          (item) =>
            !(
              item.alertId === alertId &&
              item.camId === camId &&
              item.name === name
            )
        )
      );
    } else {
      setSelectedYml((pre) => [...pre, { alertId, camId, name }]);
    }
  };
  const handleDelete = async () => {
    if (latestYml?._id) {
      const url = apiEndPoint().UPDATE_YML_FILE;
      const { status, data } = await postApi({
        url,
        params: { id: latestYml?._id, selectedYml },
      });
      console.log(status, data);
      const sendSocket = {
        projectId: selectedProject,
        warehouseId: latestYml?.siteId,
        deviceId: latestYml?.deviceId,
        command: "yaml-update",
        responseId: Date.now(),
      };
      console.log(sendSocket, "send to socket");
      socket2.emit("sendMessageToDevice", sendSocket);
      tostMessage(status, data?.message);
      setRerun((pre) => !pre);
      setHlsLink(null);
      socket.emit("start_pipeline", {
        project_id: selectedProject,
        sent_by: "ME",
      });
      setSelectedYml([]);
    }
  };
  const isExist = (alertId, camId, name) => {
    const data = selectedYml.filter(
      (item) =>
        item.alertId === alertId && item.camId === camId && item.name === name
    );
    return data.length > 0;
  };
  if (loading2) {
    return (
      <div
        style={{
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Lottie options={defaultOptions} height={200} width={400} />
        <div
          style={{
            color: "green",
            fontSize: "16px",
            fontWeight: "800",
          }}
        >
          Please wait, video is loading...
        </div>
      </div>
    );
  }
  if (loading) {
    return <MainLoader />;
  }
  return (
    <div style={{ marginTop: "2rem" }}>
      <div>
        <Radio.Group
          block
          options={options}
          value={selectedOptions}
          optionType="button"
          onChange={handleSelect}
        />
      </div>
      <div style={{ marginTop: "2rem" }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <div
              className={styles.boxPlay1}
              style={{ width: "100%", height: "73vh" }}
            >
              {hlsLink ? (
                <HlsVideoPlayer hlsUrl={hlsLink} />
              ) : editYml?.length === 0 ? (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Empty />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  {true ? (
                    <div
                      style={{
                        fontWeight: "bold",
                        lineHeight: "500px",
                        fontSize: "20px",
                      }}
                    >
                      No Live Camera Found
                    </div>
                  ) : (
                    <div className="loader10"></div>
                  )}
                </div>
              )}
            </div>
          </Grid>
          <Grid item xs={4}>
            <Badge.Ribbon
              text="Edit Configuration"
              placement="start"
              color="cyan"
            >
              <div
                className={styles.boxPlay2}
                style={{ width: "100%", paddingTop: "3rem" }}
              >
                {editYml?.length ? (
                  editYml?.map((item2) => {
                    return (
                      <Badge.Ribbon
                        text={
                          Object.keys(selectedAlert)?.length !== 0 &&
                          selectedAlert[item2?.usecaseId]
                        }
                        placement="start"
                        style={{ fontSize: "10px" }}
                      >
                        <div className={styles.boxforsource}>
                          {item2?.sources?.map((item3) => {
                            let list = [];
                            if (item3.lineCrossing.length !== 0) {
                              list.push({
                                key: "1",
                                label: "Line Crossing",
                                children: (
                                  <ol
                                    style={{
                                      paddingLeft: "1rem",
                                      paddingTop: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {item3.lineCrossing.map((item) => (
                                      <li style={{ marginBottom: "0.5rem" }}>
                                        {" "}
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div style={{ fontSize: "16px" }}>
                                            {item?.name}
                                          </div>

                                          <Button
                                            size="small"
                                            danger={isExist(
                                              item2?.usecaseId,
                                              item3?.cameraId,
                                              item?.name
                                            )}
                                            type="primary"
                                            onClick={() =>
                                              handleSelcet(
                                                item2?.usecaseId,
                                                item3?.cameraId,
                                                item?.name,
                                                isExist(
                                                  item2?.usecaseId,
                                                  item3?.cameraId,
                                                  item?.name
                                                )
                                              )
                                            }
                                            icon={
                                              isExist(
                                                item2?.usecaseId,
                                                item3?.cameraId,
                                                item?.name
                                              ) ? (
                                                <MinusSquareOutlined />
                                              ) : (
                                                <PlusSquareOutlined />
                                              )
                                            }
                                          />
                                        </div>
                                      </li>
                                    ))}
                                  </ol>
                                ),
                              });
                            }
                            if (item3.roi?.length !== 0) {
                              list.push({
                                key: "2",
                                label: "Mark Area",
                                children: (
                                  <ol
                                    style={{
                                      paddingLeft: "1rem",
                                      paddingTop: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {item3.roi.map((item) => (
                                      <li style={{ marginBottom: "0.5rem" }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div style={{ fontSize: "16px" }}>
                                            {item?.name}
                                          </div>

                                          <Button
                                            size="small"
                                            danger={isExist(
                                              item2?.usecaseId,
                                              item3?.cameraId,
                                              item?.name
                                            )}
                                            type="primary"
                                            onClick={() =>
                                              handleSelcet(
                                                item2?.usecaseId,
                                                item3?.cameraId,
                                                item?.name,
                                                isExist(
                                                  item2?.usecaseId,
                                                  item3?.cameraId,
                                                  item?.name
                                                )
                                              )
                                            }
                                            icon={
                                              isExist(
                                                item2?.usecaseId,
                                                item3?.cameraId,
                                                item?.name
                                              ) ? (
                                                <MinusSquareOutlined />
                                              ) : (
                                                <PlusSquareOutlined />
                                              )
                                            }
                                          />
                                        </div>
                                      </li>
                                    ))}
                                  </ol>
                                ),
                              });
                            }
                            return (
                              <div>
                                <Divider
                                  style={{
                                    borderColor: "#7cb305",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginBlock: "0.5rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {deviceList[item3?.cameraId] &&
                                      deviceList[item3?.cameraId]}
                                  </div>
                                </Divider>
                                <Collapse items={list} />
                              </div>
                            );
                          })}
                        </div>
                      </Badge.Ribbon>
                    );
                  })
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Empty />
                  </div>
                )}
              </div>
            </Badge.Ribbon>
          </Grid>
          <Grid item xs={12}>
            {timeSeriesData?.project_id && (
              <div className={styles.boxPlay1}>
                {Object.keys(timeSeriesData.data)?.map((item, i) => {
                  return (
                    <div key={i}>
                      <div>
                        <Divider
                          style={{
                            borderColor: "#7cb305",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "20px",
                              marginBlock: "0.5rem",
                              fontWeight: "bold",
                            }}
                          >
                            {selectedAlert[item] && selectedAlert[item]}
                          </div>
                        </Divider>
                      </div>
                      <Grid container spacing={2}>
                        {timeSeriesData.data[item] &&
                          Object.keys(timeSeriesData.data[item])?.map(
                            (item2, i2) => {
                              return (
                                <Grid item xs={6} key={i2}>
                                  <Badge.Ribbon
                                    text={
                                      deviceList[item2] && deviceList[item2]
                                    }
                                    placement="start"
                                  >
                                    <div className={styles.sources}>
                                      <div>
                                        {timeSeriesData.data[item][
                                          item2
                                        ].hasOwnProperty("lc") && (
                                          <div>
                                            <Divider
                                              style={{
                                                borderColor: "#000",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontSize: "14px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Line Crossing
                                              </div>
                                            </Divider>
                                            <div className={styles.overflowBox}>
                                              {Object.keys(
                                                timeSeriesData.data[item][
                                                  item2
                                                ]["lc"]
                                              ).map((item3, i3) => {
                                                return (
                                                  <div
                                                    className={styles.lc}
                                                    key={i3}
                                                  >
                                                    <div
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize: "16px",
                                                        color: "blue",
                                                      }}
                                                    >
                                                      {item3}
                                                    </div>

                                                    <div
                                                      className={
                                                        styles.overflowBox
                                                      }
                                                    >
                                                      {timeSeriesData.data[
                                                        item
                                                      ][item2]["lc"][item3] &&
                                                        Object.keys(
                                                          timeSeriesData.data[
                                                            item
                                                          ][item2]["lc"][item3]
                                                        ).map((item4, i4) => {
                                                          return (
                                                            <div
                                                              key={i4}
                                                              style={{
                                                                marginRight:
                                                                  "10px",
                                                                fontSize:
                                                                  "16px",
                                                                fontWeight:
                                                                  "bold",
                                                                textTransform:
                                                                  "capitalize",
                                                                minWidth: "47%",
                                                                paddingBottom:
                                                                  "0.4rem",
                                                              }}
                                                            >
                                                              {item4} :{" "}
                                                              {timeSeriesData
                                                                .data[item][
                                                                item2
                                                              ]["lc"][item3][
                                                                item4
                                                              ] &&
                                                                timeSeriesData
                                                                  .data[item][
                                                                  item2
                                                                ]["lc"][item3][
                                                                  item4
                                                                ]}
                                                            </div>
                                                          );
                                                        })}
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      <div>
                                        {timeSeriesData.data[item][
                                          item2
                                        ].hasOwnProperty("roi") && (
                                          <div>
                                            <Divider
                                              style={{
                                                borderColor: "#000",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontSize: "14px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Area Marked
                                              </div>
                                            </Divider>
                                            <div className={styles.overflowBox}>
                                              {Object.keys(
                                                timeSeriesData.data[item][
                                                  item2
                                                ]["roi"]
                                              ).map((item3, i5) => {
                                                return (
                                                  <div
                                                    className={styles.lc}
                                                    key={i5}
                                                  >
                                                    <div
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize: "16px",
                                                        color: "blue",
                                                      }}
                                                    >
                                                      {item3}
                                                    </div>

                                                    <div
                                                      className={
                                                        styles.overflowBox
                                                      }
                                                    >
                                                      {timeSeriesData.data[
                                                        item
                                                      ][item2]["roi"][item3] &&
                                                        Object.keys(
                                                          timeSeriesData.data[
                                                            item
                                                          ][item2]["roi"][item3]
                                                        ).map((item4, i6) => {
                                                          return (
                                                            <div
                                                              key={i6}
                                                              style={{
                                                                marginRight:
                                                                  "10px",
                                                                fontSize:
                                                                  "16px",
                                                                fontWeight:
                                                                  "bold",
                                                                textTransform:
                                                                  "capitalize",
                                                                minWidth: "47%",
                                                                paddingBottom:
                                                                  "0.4rem",
                                                              }}
                                                            >
                                                              {item4} :{" "}
                                                              {timeSeriesData
                                                                .data[item][
                                                                item2
                                                              ]["roi"][item3][
                                                                item4
                                                              ] &&
                                                                timeSeriesData
                                                                  .data[item][
                                                                  item2
                                                                ]["roi"][item3][
                                                                  item4
                                                                ]}
                                                            </div>
                                                          );
                                                        })}
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Badge.Ribbon>
                                </Grid>
                              );
                            }
                          )}
                      </Grid>
                    </div>
                  );
                })}
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            {voilationData.data &&
              Object.keys(voilationData.data)?.map((item, i7) => (
                <Badge.Ribbon
                  text={deviceList[item] && deviceList[item]}
                  placement="start"
                  color="green"
                  key={i7}
                >
                  <div className={styles.boxPlay1}>
                    {voilationData?.data[item] &&
                      Object.keys(voilationData?.data[item])?.map(
                        (item2, i8) => {
                          return (
                            <div key={i8}>
                              <div>
                                <Divider
                                  style={{
                                    borderColor: "#7cb305",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      marginBlock: "0.5rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item2}
                                  </div>
                                </Divider>
                              </div>
                              <div>
                                {voilationData?.data[item][item2] && (
                                  <NewCardComp
                                    data={voilationData?.data[item][item2]}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        }
                      )}
                  </div>
                </Badge.Ribbon>
              ))}
          </Grid>
        </Grid>
      </div>
      {selectedYml.length > 0 && (
        <Popconfirm
          placement="topLeft"
          title="Delete the making"
          description="Are you sure to delete this marking?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <FloatButton
            onClick={() => console.log("onClick")}
            icon={<DeleteOutlined />}
            style={{
              insetInlineEnd: 25,
              backgroundColor: "red",
              borderColor: "red",
              color: "white",
            }}
          />
        </Popconfirm>
      )}
    </div>
  );
}

export default React.memo(NewPlayGround);
